import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the handling actions dispatched from the supervision cards. */
const WorkflowRunsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="WORKFLOW_RUN_HANDLED"
				title="Traitement marqué comme traité"
				message="Il ne figure plus parmi les traitements à surveiller."
			/>
			<SuccessNotification
				eventName="WORKFLOW_RUN_UNHANDLED"
				title="Traitement remis à surveiller"
				message="Il figure de nouveau parmi les traitements à surveiller."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_HANDLING_FAILED"
				title="Erreur"
				message="Le traitement n'a pas pu être mis à jour."
			/>
		</React.Fragment>
	);
};

export default WorkflowRunsNotifications;
